export default [{
  path: 'sensitive',
  name: 'sensitive',
  component: () => import('./sensitive')
}, {
  path: 'manager',
  name: 'manager',
  component: () => import('./manage'),
  meta: {
    code: '/console/admin.htm'
  }
}, {
  path: 'plat-manage',
  name: 'plat-manage',
  component: () => import('./plat-manage/index.vue'),
  meta: {
    code: '/console/platformAdmin.htm'
  }
}, {
  path: 'feedback/user',
  name: 'feedback-user',
  component: () => import('./feedback-application/user'),
  meta: {
    code: '/console/advice.htm'
  }
}, {
  path: 'feedback/agent-application',
  name: 'feedback-agent-application',
  component: () => import('./feedback-application/agent-application/index.vue'),
  meta: {
    code: '/console/agentApply.htm'
  }
}, {
  path: 'feedback/disease',
  name: 'feedback-disease',
  component: () => import('./feedback-application/disease-drug'),
  meta: {
    code: '/console/drugAdvice.htm'
  }
}, {
  path: 'feedback/urgent',
  name: 'feedback-urgent',
  component: () => import('./feedback-application/drug-urgent'),
  meta: {
    code: '/basic/drugInstructions.htm'
  }
}, {
  path: 'setting/system-args-manage',
  name: 'system-args-manag',
  component: () => import('./setting-manage/system-manage/index.vue'),
  meta: {
    code: '/console/systemParams.htm'
  }
}, {
  path: 'setting/limit-setting',
  name: 'limit-setting',
  component: () => import('./setting-manage/limit-manage'),
  meta: {
    code: '/console/auth.htm'
  }
}, {
  path: 'setting/edition-manage',
  name: 'edition-manage',
  component: () => import('./setting-manage/edition-manage'),
  meta: {
    code: '/console/forceUpdate.htm'
  }
}, {
  path: 'settins/header-setting',
  name: 'header-setting',
  component: () => import('./setting-manage/header-manage'),
  meta: {
    code: '/basic/flowExcelTitle.htm'
  }
}, {
  path: 'settings/menu-settings',
  name: 'menu-setting',
  component: () => import('./setting-manage/menu-setting'),
  meta: {
    code: '/console/menu.htm'
  }
}, {
  path: 'settins/about',
  name: 'settinds-about',
  component: () => import('./setting-manage/about-zhiyao'),
  meta: {
    code: '/console/zhiyaoDescription.htm'
  }
}, {
  path: 'sql-exe',
  name: 'sql-exe',
  component: () => import('./sql-exe'),
  meta: {
    code: '/console/script.htm'
  }
}, {
  path: 'pc-update-time',
  name: 'pc-update-time',
  component: () => import('./setting-manage/pc-update-time/index.vue'),
  meta: {
    code: '/basic/noticeModify.htm'
  }
}, {
  path: 'pc-update-copywriting',
  name: 'pc-update-copywriting',
  component: () => import('./setting-manage/pc-update-copywriting/index.vue'),
  meta: {
    code: '/console/pcUpdate.htm'
  }
}, {
  path: '/user-help',
  name: 'user-help',
  component: () => import('./user-help/index.vue'),
  meta: {
    code: '/console/useHelpInfo.htm'
  }
}, {
  path: '/plat-setting',
  name: 'plat-setting',
  component: () => import('./plat-setting/index.vue'),
  meta: {
    code: '/console/platConfigParams.htm'
  }
}];



// WEBPACK FOOTER //
// ./src/views/system/index.route.js